import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Card component that can use an attribute or slot for
 * - `title`
 * - `icon`/`image`: if there is not `icon` attribute, `<slot="image"/>` will be used
 */
var LoyaltyCardComponent = /** @class */ (function (_super) {
    __extends(LoyaltyCardComponent, _super);
    function LoyaltyCardComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], LoyaltyCardComponent.prototype, "icon", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], LoyaltyCardComponent.prototype, "title", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LoyaltyCardComponent.prototype, "elevation", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LoyaltyCardComponent.prototype, "noPadding", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LoyaltyCardComponent.prototype, "smallIcon", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LoyaltyCardComponent.prototype, "light", void 0);
    LoyaltyCardComponent = __decorate([
        Component({
            name: 'loyalty-card',
        })
    ], LoyaltyCardComponent);
    return LoyaltyCardComponent;
}(Mixins(MagicConfigMixin)));

export default LoyaltyCardComponent;
